import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=0dd8a266"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_css-loader@6.11.0_webpack@5.98._lpz7yfflcfbikbc3glhfyeagle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports